import { computed } from "vue"
import moment from "moment-timezone"

/**
 * Composable for handling grade years with school year rollover logic
 * Returns current school year + 3 previous years (max 4 years total)
 * School year rolls over on July 1st each year
 */
export function useGradeYears() {
  const gradeYears = computed(() => {
    const gradeYears = []
    const currentYear = new Date().getFullYear()
    const today = moment()

    // Check if we're in the new school year
    const rolloverDate = moment(`${currentYear}-07-01 00:00:00`)
    const newSchoolYear = today.isSameOrAfter(rolloverDate)

    // Determine the current school year
    const currentSchoolYearStart = newSchoolYear ? currentYear : currentYear - 1

    // Generate 4 school years: current + 3 previous
    for (let i = 3; i >= 0; i--) {
      const startYear = currentSchoolYearStart - i
      const endYear = startYear + 1

      gradeYears.push({
        value: [startYear, endYear],
        label: `${startYear}-${endYear.toString().slice(-2)}`
      })
    }

    return gradeYears
  })

  const currentSchoolYear = computed(() => {
    return gradeYears.value[gradeYears.value.length - 1]
  })

  const getMinDate = (schoolYear) => {
    if (schoolYear?.value) {
      return new Date(schoolYear.value[0], 6, 1) // July 1st
    }
    return new Date()
  }

  const getMaxDate = (schoolYear) => {
    if (schoolYear?.value) {
      return new Date(schoolYear.value[1], 5, 30) // June 30th
    }
    return new Date()
  }

  return {
    gradeYears,
    currentSchoolYear,
    getMinDate,
    getMaxDate
  }
}
